export default __webpack_public_path__ + "static/logo-svg-w-5e6ba52edc9fcbe25bf8aa3983551b96.svg";